import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import MobileNavbar from './MobileNavbar';
import { useAuth } from '../../context/AuthContext';
const MainLayout: React.FC = () => {
  const {
    isAuthenticated
  } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  // Redirect to login if not authenticated
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login', {
        replace: true
      });
    }
  }, [isAuthenticated, navigate]);
  // Close mobile menu when changing routes
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);
  return <div className="flex min-h-screen bg-gray-100" data-id="element-60">
      {/* Sidebar for desktop */}
      <div className="hidden md:block" data-id="element-61">
        <Sidebar data-id="element-62" />
      </div>
      {/* Mobile navigation */}
      <MobileNavbar data-id="element-63" />
      {/* Main content */}
      <div className="flex-1 md:ml-64 pt-4 md:pt-0 pb-20 md:pb-0" data-id="element-64">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-6" data-id="element-65">
          <Outlet data-id="element-66" />
        </div>
      </div>
    </div>;
};
export default MainLayout;